import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';

import { TProviderUser, TProviderUserPayloadRequest, TProviderUserResponse, adaptProviderUserFromResponse, adaptProviderUserToRequest } from '../../types';
import { TSliceInitialState, useAppSelector } from '../../hooks';
import { BACKEND_ADMIN_PROVIDER_USER } from '../../backend-paths';


export const providerUserCreateApi = createAsyncThunk(
	`POST/${BACKEND_ADMIN_PROVIDER_USER}`,
	(payload: TProviderUserPayloadRequest, thunkApi) => {
		const dataRequest = adaptProviderUserToRequest(payload);

		return HttpService.post<TProviderUserResponse>(BACKEND_ADMIN_PROVIDER_USER, dataRequest).then(result => {
			return adaptProviderUserFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

const initialState: TSliceInitialState<TProviderUser> = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const providerUserCreateSlice = createSlice({
	name: 'providerUserCreateSlice',
	initialState,
	reducers: {
		clearProviderUserCreate(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[providerUserCreateApi.pending.type]: (state) => {
			state.error = undefined;
			state.isLoading = true;
		},

		[providerUserCreateApi.fulfilled.type]: (state, action: PayloadAction<TProviderUser>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[providerUserCreateApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.error = action.payload;
			state.isLoading = false;
		},
	},
});

export const useProviderUserCreateSelector = () => useAppSelector(state => state[providerUserCreateSlice.name]);

export const { clearProviderUserCreate } = providerUserCreateSlice.actions;
